import { PetController } from './PetController';

let pet: PetController;
export function getPet() {
  if (!pet) {
    throw new Error('Pet Controller not configured');
  }
  return pet;
}

export function setPet(controller: PetController) {
  if (pet && controller) {
    throw new Error('Pet Controller already defined');
  }
  pet = controller;
}

let friendsPet: PetController;
export function getFriendsPet() {
  return friendsPet;
}

export function setFriendsPet(controller: PetController) {
  if (friendsPet && controller) {
    throw new Error(`Friend's pet Controller already defined`);
  }
  friendsPet = controller;
}
